import styled from 'styled-components';

export const WarningBarDiv = styled.div`
	width: 100%;
	text-align: center;
	background-color: rgba(247, 205, 205, 0.38);
	padding: 10px;
	font-size: 0.75rem;
`;
